import { useNavigate } from 'react-router-dom'

export const useGoToUniversalSearchProduct = () => {
  const navigate = useNavigate()

  return {
    go: () => {
      navigate(UNIVERSAL_SEARCH_PRODUCT_URL)
    }
  }
}

export const UNIVERSAL_SEARCH_PRODUCT_URL = '/universal-search/product'
